import { defaultMemoize } from 'reselect';
import _map from 'lodash/map';
import _find from 'lodash/find';
import _flatMap from 'lodash/flatMap';
import _isObject from 'lodash/isObject';
import _filter from 'lodash/filter';
import _every from 'lodash/every';
import _keyBy from 'lodash/keyBy';
import _includes from 'lodash/includes';
import _negate from 'lodash/negate';
import { EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';
var getSelectOptionItem = function getSelectOptionItem(mapper, option) {
  return {
    value: mapper.getOptionValue(option),
    label: mapper.getOptionLabel(option),
    optionData: mapper.getOptionData(option)
  };
};
export var getOptions = function getOptions(mapper, options) {
  return _map(options, function (option) {
    if (option.value && option.label) return option;
    return getSelectOptionItem(mapper, option);
  });
};
var isSelectedValueStatic = function isSelectedValueStatic(staticOptions, value) {
  return _find(staticOptions, function (option) {
    return option.value === value;
  });
};
export var getSanitizedValue = function getSanitizedValue(mapper, staticOptions) {
  return defaultMemoize(function (value, cache) {
    return _flatMap(value, function (valueId) {
      if (!valueId) return EMPTY_ARRAY;
      if (_isObject(valueId)) return [valueId];
      if (isSelectedValueStatic(staticOptions, valueId)) return cache[valueId];
      return cache[valueId] ? [getSelectOptionItem(mapper, cache[valueId])] : [valueId];
    });
  });
};
export var getValueIds = function getValueIds(values) {
  return _filter(values, function (value) {
    return !!value && !_isObject(value);
  });
};
export var getDefaultFilterOption = function getDefaultFilterOption() {
  return true;
};
export var hasValueInCache = function hasValueInCache(values, cache) {
  return _every(values, function (selectedValue) {
    return cache[selectedValue];
  });
};
export var getSelectedValueCache = function getSelectedValueCache(staticOptions) {
  var staticOptionsResources = _keyBy(staticOptions, 'value');
  return staticOptionsResources;
};
export var searchStaticOptions = function searchStaticOptions(staticOptions, inputString) {
  var resultantOptions = _filter(staticOptions, function (staticOption) {
    var label = staticOption.label;
    var isValid = _includes(label, inputString);
    return isValid;
  });
  return resultantOptions;
};
export var getValuesToBeResolved = function getValuesToBeResolved(value) {
  return _filter(value, _negate(_isObject));
};